import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import ProtectedRoute from './components/services/protected-route';
import Login from './components/users/login';
import Register from './components/users/register';
import Home from './components/pages/general/home';
import LoadingIndicator from './components/pages/general/LoadingIndicator';
import Header from './components/pages/general/header';
import Footer from './components/pages/general/footer';
import Profile from './components/users/profile';
import ResetPassword from './components/users/reset-password';
import Navbar from './components/pages/general/navbar';
import Documentation from './components/pages/general/Documentation';
import AddSms from './components/services/add/sms';
import AddPopup from './components/services/add/popup';
import AddEmail from './components/services/add/email';
import AddPushNotification from './components/services/add/push-notification';
import ViewCreative from './components/pages/view/creative';
import EditCreative from './components/services/edit/editCreative';
import { AuthProvider } from './components/services/check_login';
import AddLanguage from './components/services/add/language';
import Library from './components/pages/view/CreativeTable'
import InactivityLogout from './components/services/InactivityLogout';
import CreateBrandForm from './components/services/add/brand-create';
import AiAssistant from './components//services/ai_assistant/ready_text';
import RoleManagement from './components/pages/roles/RoleManagement';
import UserManagement from './components/pages/users/UserManagement';
import StatusManagement from './components/pages/statuses/StatusManagement';
import TemplateBuilder from './components/pages/email-builder/TemplateBuilder';
import EmailTemplatesList from './components/pages/email-templates/EmailTemplatesList';
import PlaceholderManagement from './components/pages/general/PlaceholderManagement';
import Analytics from './components/pages/analytics/Analytics';
import MarketingCalendar from './components/pages/campaigns/MarketingCalendar';
import Integrations from './components/pages/integrations/Integrations';


import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/bootstrap-theme.css';
import './assets/css/global.css';
import './assets/css/dark-mode.css';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
};

const AppContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthPage = ['/login', '/register'].includes(location.pathname);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => localStorage.getItem('sidebarCollapsed') === 'true');

  const toggleSidebar = () => {
    setSidebarCollapsed(prev => {
      const next = !prev;
      localStorage.setItem('sidebarCollapsed', next);
      return next;
    });
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token && !isAuthPage) {
      navigate('/login');
      return;
    }

    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const isExpired = payload.exp * 1000 < Date.now();
      if (isExpired) {
        localStorage.removeItem('token');
        navigate('/login');
      }
    }
  }, [navigate, isAuthPage]);

  return (
    <div className="app-container">
      {!isAuthPage && <Navbar collapsed={sidebarCollapsed} onToggleSidebar={toggleSidebar} />}

      <div className={`main-content ${isAuthPage ? 'auth-page' : ''} ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        {!isAuthPage && <Header />}
        
        <div className="content-wrapper">
        <Routes>
              <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<ProtectedRoute><Register /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/reset-password" element={<ProtectedRoute><ResetPassword /></ProtectedRoute>} />
              <Route path="/documentation" element={<ProtectedRoute><Documentation /></ProtectedRoute>} />
              <Route path="/add-sms" element={<ProtectedRoute><AddSms  pageTitle="Create SMS" /></ProtectedRoute>} />
              <Route path="/add-popup" element={<ProtectedRoute><AddPopup pageTitle="Create Popup"  /></ProtectedRoute>} />
              <Route path="/add-push-notification" element={<ProtectedRoute><AddPushNotification pageTitle="Create Push Notification"  /></ProtectedRoute>} />
              <Route path="/add-email" element={<ProtectedRoute><AddEmail pageTitle="Create Email"  /></ProtectedRoute>} />
              <Route path="/language" element={<ProtectedRoute><AddLanguage pageTitle="Languages"  /></ProtectedRoute>} />
              <Route path="/brand/create" element={<ProtectedRoute><CreateBrandForm pageTitle="Brands"  /></ProtectedRoute>} />
              <Route path="/view/:lang/:id" element={<ProtectedRoute><ViewCreative pageTitle="Creavie View"  /></ProtectedRoute>} />
              <Route path="/library/creatives" element={<ProtectedRoute><Library pageTitle="Library"  /></ProtectedRoute>} />
              <Route path="/creative/edit/:lang/:id" element={<ProtectedRoute><EditCreative pageTitle="Edit Creative"  /></ProtectedRoute>} />
              <Route path="/brand/list" element={<Navigate to="/brand/create" replace />} />
              <Route path="/ai-assistant" element={<ProtectedRoute><AiAssistant pageTitle="Welcome to your Ai Assistant"  /></ProtectedRoute>} />
              <Route path="/roles/manage" element={<ProtectedRoute><RoleManagement pageTitle="Role Management"  /></ProtectedRoute>} />
              <Route path="/users/manage" element={<ProtectedRoute><UserManagement pageTitle="User Management"  /></ProtectedRoute>} />
              <Route path="/statuses/manage" element={<ProtectedRoute><StatusManagement pageTitle="Status Management"  /></ProtectedRoute>} />
              <Route path="/email-builder" element={<ProtectedRoute><TemplateBuilder /></ProtectedRoute>} />
              <Route path="/email-templates/list" element={<ProtectedRoute><EmailTemplatesList /></ProtectedRoute>} />
              <Route path="/placeholders/manage" element={<ProtectedRoute><PlaceholderManagement pageTitle="Placeholder Management"  /></ProtectedRoute>} />
              <Route path="/analytics" element={<ProtectedRoute><Analytics pageTitle="Analytics Dashboard"  /></ProtectedRoute>} />
              <Route path="/marketing-calendar" element={<ProtectedRoute><MarketingCalendar pageTitle="Marketing Calendar" /></ProtectedRoute>} />
              <Route path="/integrations" element={<ProtectedRoute><Integrations pageTitle="Integrations" /></ProtectedRoute>} />
              
            </Routes>
        </div>
      </div>
    </div>
  );
};

export default App;
